import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

import MDInput from "components/MDInput";

function CustomDateTimePicker({ label, value, onDateSelected, error, success, helperText }) {
  // Logic: Use existing value if present, otherwise null.
  // If you want it to default to "Now", use: value ? dayjs(value) : dayjs()
  const dateValue = value ? dayjs(value) : null;

  const handleChange = (newValue) => {
    // Only update if the date is valid to prevent "Invalid Date" strings in your state
    if (newValue && newValue.isValid()) {
      onDateSelected(newValue.format("YYYY-MM-DDTHH:mm:ss"));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDateTimePicker
        label={label}
        format="YYYY-MM-DD HH:mm:ss"
        ampm={false}
        views={["year", "day", "hours", "minutes", "seconds"]}
        value={dateValue}
        onChange={handleChange}
        slots={{
          textField: (params) => (
            <MDInput
              {...params}
              fullWidth
              error={error}
              success={success}
              helperText={helperText}
              // readOnly prevents the keyboard from popping up on mobile
              // and ensures the user uses the picker UI
              inputProps={{ ...params.inputProps, readOnly: true }}
            />
          ),
        }}
        slotProps={{
          actionBar: {
            actions: ["clear", "cancel", "accept"],
          },
        }}
      />
    </LocalizationProvider>
  );
}

CustomDateTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  onDateSelected: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  helperText: PropTypes.string,
};

export default CustomDateTimePicker;
